import {useState} from "react";
import './_toolbar.scss';
import puzzles from "../../../utils/puzzles";
import VStore from "../../../store";

const Toolbar = () => {
    const {currentMode, isMobile, sendMessage} = VStore();

    const [isShownTemperature, setIsShownTemperature] = useState(true);

    function setFreeMode() {
        if (isMobile) {
            sendMessage('Chế độ này chỉ khả dụng trên máy tính hoặc máy tính bảng');
        } else {
            puzzles.procedures?.setFreeMode();
        }
    }

    function setFPSMode() {
        if (isMobile) {
            sendMessage('Chế độ này chỉ khả dụng trên máy tính hoặc máy tính bảng');
        } else {
            puzzles.procedures?.setFPSMode();
        }
    }

    function set360Mode() {
        if (!isMobile) {
            puzzles.procedures?.set360Mode();
        }
    }

    return <div className="toolbar-container">
        <div>
            <button id='fps-btn'
                    className={'fps-btn' + (currentMode === 'fps' ? ' active' : '') + (isMobile ? ' disabled' : '')}
                    onClick={setFPSMode}
            >
                <img src="./assets/images/fps.svg" alt="Fps"/>
            </button>
            <button id='free-btn'
                    className={'free-btn' + (currentMode === 'free' ? ' active' : '') + (isMobile ? ' disabled' : '')}
                    onClick={setFreeMode}
            >
                <img src="./assets/images/fly.svg" alt="Fly"/>
            </button>
            <button id='mode-360-btn'
                    className={'mode-360-btn' + (currentMode === '360' ? ' active' : '')}
                    onClick={set360Mode}
            >
                <img src="./assets/images/image360.svg" alt="360"/>
            </button>
            <button id='temperature-btn'
                    className={'temperature-btn' + (isShownTemperature ? ' active' : '')}
                    onClick={() => setIsShownTemperature(!isShownTemperature)}
            >
                <img src="./assets/images/temperature.svg" alt="Temperature"/>
            </button>
            {/*<button id='info-btn'
                    className='info-btn'
            >
                <img src="./assets/images/info.svg" alt="Information"/>
            </button>*/}
        </div>
    </div>
}

export default Toolbar;
